/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { ClientsService } from '@app/clients/clients/clients.service';
import { ClientsFormService } from '@app/clients/clients/clients-form.service';
import { Logger } from '@app/core';
import { Client } from '@app/clients/clients/client.model';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '@env/environment';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';
import { LaravelModelsEnum } from '@app/shared/models/model.model';

const log = new Logger('ClientsListComponent');

@Component({
  selector: 'app-clients-list',
  templateUrl: './clients-list.component.html',
  styleUrls: ['./clients-list.component.scss'],
})
export class ClientsListComponent extends KendoGridComponent implements OnInit {
  clientsResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  form: FormGroup;
  env = environment;

  UserRoleType = UserRoleType;

  LaravelModelsEnum = LaravelModelsEnum;

  constructor(
    private clientService: ClientsService,
    private clientsFormService: ClientsFormService,
    protected kendoGridService: KendoGridService,
    private formBuilder: FormBuilder,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('ClientsListComponent');
    this.createForm();
    this.loadData(this.state);
  }

  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery.setDataSetFilters(state).addIncludes('type', 'city', 'country', 'contacts.type');

    let searchStr = this.form.get('keywords').value;

    if (this.form.get('exact').value && this.form.get('keywords').value) {
      searchStr = '"' + searchStr + '"';
    }
    this.apiQuery.handleKeyword(searchStr);
    this.clientService.search(searchStr, this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.clientsResponse = response;
      this.data = response.getGridData();
    });

    CustomKendoFilter.pushStateInStorage('ClientsListComponent', this.state);
  }

  add() {
    this.clientsFormService.open().then(
      (response) => {
        this.loadData(this.state);
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *
   * @param client Client object
   */
  edit(client: Client) {
    this.clientsFormService.open(client).then((res) => {
      this.loadData(this.state);
    });
  }

  /**
   *
   * @param client Client object
   */
  delete(client: Client) {
    this.clientService.destroy(client.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  clearFilters() {
    // може и с this.form.reset(), но сетва false(или null) на exact, а трябва да е true
    this.form.patchValue({
      keywords: null,
      exact: true,
    });
    this.apiQuery = new ApiQuery();
    this.loadData();
  }

  private createForm() {
    this.form = this.formBuilder.group({
      keywords: [null],
      exact: [true],
    });
  }
}
